import { gql } from '@apollo/client/core'
import { useMutation } from '@vue/apollo-composable'
import { IForgotPasswordResponse } from '@types'

const FORGOT_PASSWORD_MUTATION = gql`
  mutation Mutation($forgotPasswordInput: ForgotPasswordInput!) {
    forgotPassword(forgotPasswordInput: $forgotPasswordInput) {
      type
      payload {
        ... on StringResponse {
          message
        }
      }
    }
  }
`

export const useForgotPasswordMutation = () => {
  const mutation = useMutation<IForgotPasswordResponse>(FORGOT_PASSWORD_MUTATION)
  return mutation
}
